// Subjects Types
export const SUBJECTS_FETCH_REQUEST = "SUBJECTS_FETCH_REQUEST";
export const SUBJECTS_FETCH_SUCCESS = "SUBJECTS_FETCH_SUCCESS";
export const SUBJECTS_FETCH_FAILURE = "SUBJECTS_FETCH_FAILURE";

export const SUBJECT_CREATE_REQUEST = "SUBJECT_CREATE_REQUEST";
export const SUBJECT_CREATE_SUCCESS = "SUBJECT_CREATE_SUCCESS";
export const SUBJECT_CREATE_FAILURE = "SUBJECT_CREATE_FAILURE";

export const SUBJECT_UPDATE_REQUEST = "SUBJECT_UPDATE_REQUEST";
export const SUBJECT_UPDATE_SUCCESS = "SUBJECT_UPDATE_SUCCESS";
export const SUBJECT_UPDATE_FAILURE = "SUBJECT_UPDATE_FAILURE";

export const SUBJECT_DELETE_REQUEST = "SUBJECT_DELETE_REQUEST";
export const SUBJECT_DELETE_SUCCESS = "SUBJECT_DELETE_SUCCESS";
export const SUBJECT_DELETE_FAILURE = "SUBJECT_DELETE_FAILURE";

// Units Types
export const UNITS_FETCH_REQUEST = "UNITS_FETCH_REQUEST";
export const UNITS_FETCH_SUCCESS = "UNITS_FETCH_SUCCESS";
export const UNITS_FETCH_FAILURE = "UNITS_FETCH_FAILURE";

export const UNIT_CREATE_REQUEST = "UNIT_CREATE_REQUEST";
export const UNIT_CREATE_SUCCESS = "UNIT_CREATE_SUCCESS";
export const UNIT_CREATE_FAILURE = "UNIT_CREATE_FAILURE";

export const UNIT_UPDATE_REQUEST = "UNIT_UPDATE_REQUEST";
export const UNIT_UPDATE_SUCCESS = "UNIT_UPDATE_SUCCESS";
export const UNIT_UPDATE_FAILURE = "UNIT_UPDATE_FAILURE";

export const UNIT_DELETE_REQUEST = "UNIT_DELETE_REQUEST";
export const UNIT_DELETE_SUCCESS = "UNIT_DELETE_SUCCESS";
export const UNIT_DELETE_FAILURE = "UNIT_DELETE_FAILURE";

// Topics Types
export const TOPICS_FETCH_REQUEST = "TOPICS_FETCH_REQUEST";
export const TOPICS_FETCH_SUCCESS = "TOPICS_FETCH_SUCCESS";
export const TOPICS_FETCH_FAILURE = "TOPICS_FETCH_FAILURE";

export const TOPIC_CREATE_REQUEST = "TOPIC_CREATE_REQUEST";
export const TOPIC_CREATE_SUCCESS = "TOPIC_CREATE_SUCCESS";
export const TOPIC_CREATE_FAILURE = "TOPIC_CREATE_FAILURE";

export const TOPIC_UPDATE_REQUEST = "TOPIC_UPDATE_REQUEST";
export const TOPIC_UPDATE_SUCCESS = "TOPIC_UPDATE_SUCCESS";
export const TOPIC_UPDATE_FAILURE = "TOPIC_UPDATE_FAILURE";

export const TOPIC_DELETE_REQUEST = "TOPIC_DELETE_REQUEST";
export const TOPIC_DELETE_SUCCESS = "TOPIC_DELETE_SUCCESS";
export const TOPIC_DELETE_FAILURE = "TOPIC_DELETE_FAILURE";

// Reset
export const SUBJECTS_UNITS_RESET = "SUBJECTS_UNITS_RESET";
